import { Container, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Stepper, Step, StepLabel, StepContent, Typography, Button, StepButton, Checkbox, FormControlLabel } from "@material-ui/core";
import jsonTests from './tests.json';
import styled from "styled-components"
import { useEffect, useMemo, useState } from "react";
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import { MasterOfActsAPI } from "../../api/api";

const TestsBlock = styled(List)`
    width: 300px;
    height: 100%;
    overflow-y: scroll;
    box-shadow: 4px 0 8px rgba(0, 0, 0, 0.1);
    border-right: 1px solid #e0e0e0;
`

const CustomContainer = styled(Container)`
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    gap: 0;
`

const QuationsContainer = styled(Container)`
    box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
    border-left: 1px solid #e0e0e0;
    display: flex;
    flex-direction: row;
    gap: 0;
`

const TestStepperContainer = styled.div`
    width: fit-content;
    height: 100%;
`

const Flex = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`

const FlexOptions = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
`;

const ImageContainer = styled.div`
    width: 100%;
    height: 300px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 8px;
`;

const StyledImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;

const createEnv = (test) => {
    const questions = test?.questions ?? [];

    return questions.map((question) => {
        return {
            ...question,
            answerOptions: question?.answerOptions.map((answer) => {
                return [answer, false]
            })
        }
    })
}

function checkUserAnswers(questionData) {
  const { id, correctAnswers, answerOptions } = questionData;
  
  // Извлекаем все варианты ответов из вложенного массива
  const allAnswerOptions = answerOptions;
  
  // Находим выбранные пользователем ответы (где значение true)
  const userAnswers = allAnswerOptions
    .filter(([answer, isSelected]) => isSelected)
    .map(([answer]) => answer);
  
  // Проверяем, все ли правильные ответы выбраны
  const allCorrectSelected = correctAnswers.every(correctAnswer => 
    userAnswers.includes(correctAnswer)
  );
  
  // Проверяем, нет ли лишних неправильных ответов
  const noIncorrectSelected = userAnswers.every(userAnswer =>
    correctAnswers.includes(userAnswer)
  );
  
  const result = allCorrectSelected && noIncorrectSelected;
  
  // Находим неправильные ответы, которые выбрал пользователь
  const incorrectAnswers = userAnswers.filter(userAnswer =>
    !correctAnswers.includes(userAnswer)
  );
  
  return {
    id,
    result,
    incorrect: result ? false : incorrectAnswers
  };
}

const caclculateResult = (list) => {
    return list.map((question) => checkUserAnswers(question))
}

export const TestsContainer = () => {
    const [test, setTest] = useState(jsonTests[0]);
    const [activeStep, setActiveStep] = useState(0);
    const [finish, setFinish] = useState(false);
    const [isFinish, setIsFinish] = useState(false);
    const [imageUrl, setImageUrl] = useState(null); // Состояние для URL изображения

    useEffect(() => {
        console.log(imageUrl, 'imageUrl')
    }, [imageUrl])

    const [testEnv, setTestEnv] = useState(createEnv(test))
    const [result, setResult] = useState(null);

    const [totalCorrect, setTotalCorrect] = useState();

useEffect(() => {
    let objectUrl = null;
    let isMounted = true;

    const loadImage = async () => {
        const currentImg = test?.questions[activeStep]?.img;
        
        if (!currentImg) {
            if (isMounted) setImageUrl(null);
            return;
        }

        try {
            console.log('Загрузка изображения ID:', currentImg);
            const response = await MasterOfActsAPI.downloadViolationFile(currentImg);
            
            if (!isMounted) return;
            
            // Берем blob из data
            const blob = response.data;
            
            if (blob && blob instanceof Blob && blob.size > 0) {
                // Создаем URL из blob
                objectUrl = URL.createObjectURL(blob);
                console.log('URL создан, размер изображения:', blob.size, 'тип:', blob.type);
                
                if (isMounted) {
                    setImageUrl(objectUrl);
                }
            } else {
                console.error('Невалидный blob:', blob);
                if (isMounted) setImageUrl(null);
            }
        } catch (error) {
            console.error('Ошибка загрузки изображения:', error);
            if (isMounted) setImageUrl(null);
        }
    };

    loadImage();

    return () => {
        isMounted = false;
        // Очищаем старый URL при размонтировании или смене изображения
        if (objectUrl) {
            URL.revokeObjectURL(objectUrl);
        }
    };
}, [activeStep, test?.questions]);

    useEffect(() => {
        setTestEnv(createEnv(test))
        setFinish(false);
        setImageUrl(null); // Сброс изображения при смене теста
    }, [test]);

    useEffect(() => {
        if (isFinish) {
            const res = caclculateResult(testEnv);
            setResult(res)
            const resCount = res.reduce((count, { result }) => count + (result ? 1 : 0), 0);
            setTotalCorrect(resCount)
        }
    }, [isFinish, testEnv])

    const answers = useMemo(() => {
        return {
            ...testEnv?.[activeStep],
            answerOptions: (testEnv?.[activeStep]?.answerOptions ?? []).sort((a, b) => {
                return a[0].localeCompare(b[0], undefined, { numeric: true, sensitivity: 'base' });
            })
        };
    }, [testEnv, activeStep]);

    const idQuestions = test?.questions[activeStep]?.id ?? undefined;

    const checkComplite = (answerOptions) => {
        return answerOptions.some((el) => el[1])
    }

    const checkAllComplite = (list) => {
        return list.every((el) => checkComplite(el.answerOptions))
    }

    const icon = (num, isActiveStep) => {
        return(
            <svg class="MuiSvgIcon-root MuiStepIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="12" fill={isActiveStep ? '#2e5485' : 'rgba(0, 0, 0, 0.38)'}></circle>
                <text class="MuiStepIcon-text" x="12" y="16" text-anchor="middle">{num}</text>
            </svg>
        )
    }

    const resultIcon = (res, id) => {
        if (!res) {
            return <></>
        }

        const isCorrect =  res?.filter((el) => el.id === id)[0].result;
        return isCorrect ? <CheckCircleIcon fontSize="medium" style={{ fill: 'green'}} color="primary" /> : <WarningIcon fontSize="medium" style={{ fill: 'red'}}/>
    }

    return (
        <CustomContainer>
            <TestsBlock
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Выберите доступный тест
                    </ListSubheader>
                }
            >
                {jsonTests.map((testEl) => {
                    return (
                        <ListItem selected={testEl.uiId === test.uiId} button onClick={() => {setTest(testEl); setActiveStep(0)}}>
                            <ListItemText primary={testEl.name} />
                        </ListItem>
                    )
                })}
            </TestsBlock>
            <QuationsContainer>
                <TestStepperContainer>
                    <Stepper nonLinear style={{ backgroundColor: '#fafafa'}} activeStep={activeStep} orientation="vertical">
                        {testEnv.map(({id, answerOptions}, index) => (
                            <Step completed={checkComplite(answerOptions)} key={`${id}+${index}`}>
                                <StepButton
                                    icon={
                                        isFinish && result
                                        ?
                                            resultIcon(result, id)
                                        :
                                        !checkComplite(answerOptions) && finish ? 
                                            <WarningIcon fontSize="medium" style={{ fill: '#FF7900'}}/> : 
                                                checkComplite(answerOptions) ? 
                                                    <CheckCircleIcon fontSize="medium" style={{ fontSize: 24 }} color="primary" /> : 
                                                    icon(index + 1, activeStep === index) 
                                        } 
                                    onClick={() => setActiveStep(index)}
                                >
                                    {index + 1}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </TestStepperContainer>
                <Flex>
                    <Typography variant="h5">{test.name}</Typography>
<ImageContainer>
        {imageUrl ? (
            <StyledImage 
                src={imageUrl} 
                alt={`Вопрос ${activeStep + 1}`}
                onError={(e) => {
                    console.error('Ошибка загрузки изображения');
                    e.target.style.display = 'none';
                }}
            />
        ) : test?.questions[activeStep]?.img ? (
            <Typography style={{ color: 'white' }}>
                Загрузка изображения...
            </Typography>
        ) : (
            <Typography style={{ color: 'white' }}>
                Изображение отсутствует
            </Typography>
        )}
    </ImageContainer>
                    <FlexOptions>
                        {answers && answers.answerOptions.map((answer, index) => {
                            return (
                                <FormControlLabel
                                    label={answer[0]}
                                    key={`${index}`}
                                    control={
                                        <Checkbox
                                            disabled={isFinish && result}
                                            color={isFinish && result && 
                                                result.filter((el) => el.id === answers.id)[0]?.incorrect?.includes(answer[0]) 
                                                ? 'secondary' 
                                                : 'primary'
                                            }
                                            style={{ color: isFinish && result && answers.correctAnswers.includes(answer[0]) ? '#4caf50' : 'primary' }}
                                            checked={answer[1]}
                                            name={`${index}`}
                                            onChange={() => setTestEnv((prev) => {
                                                return prev.map((qust) => {
                                                    if (qust.id === idQuestions) {
                                                        return {
                                                            ...qust,
                                                            answerOptions: qust.answerOptions.map((answerQust) => {
                                                                if (answerQust[0] === answer[0]) {
                                                                    return [answerQust[0], !answerQust[1]]
                                                                }
                                                                return answerQust
                                                            })
                                                        }
                                                    }
                                                    return qust
                                                })
                                            })}
                                        />
                                    }
                                />
                            )
                        })}
                    </FlexOptions>
                    <div style={{ display: 'flex', direction: 'row', gap: '16px', justifyContent: 'flex-end'}}>
                        {isFinish && 
                            <Typography>
                                {`${totalCorrect} / ${testEnv.length}`}
                            </Typography>}
                        <Button
                            variant="outlined"
                            disabled={activeStep === 0}
                            onClick={() => setActiveStep((prev) => prev - 1)}
                        >
                            {'Назад'}
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            disabled={activeStep === test.questions.length - 1 }
                            onClick={() => setActiveStep((prev) => prev + 1)}
                        >
                            {'Вперед'}
                        </Button> 
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={false}
                            onClick={() => {
                                if (checkAllComplite(testEnv)) {
                                    setIsFinish(true)
                                } else {
                                    setFinish(true)
                                }
                            }}
                        >
                            {'Завершить'}
                        </Button> 
                    </div>
                </Flex>
            </QuationsContainer>
        </CustomContainer>
    )
}